import Box from '@cloudscape-design/components/box'
import Container from '@cloudscape-design/components/container'
import Header from '@cloudscape-design/components/header'
import Link from '@cloudscape-design/components/link'
import SpaceBetween from '@cloudscape-design/components/space-between'

export default function PrivacyPage() {
  return (
    <Box padding="xxl">
      <Container>
        <SpaceBetween size="l">
          <Header variant="h1" description="Last updated: April 22, 2026">
            Privacy Policy
          </Header>

          <SpaceBetween size="m">
            <Header variant="h2">Overview</Header>
            <Box variant="p">
              Sabar ("we", "us", "our") operates the Sabar platform at{' '}
              <Link href="https://app.sabar.ai" external>
                app.sabar.ai
              </Link>
              . This Privacy Policy explains what information we collect, how we use it, and the
              choices you have.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Information We Collect</Header>
            <Box variant="p">
              We collect information you provide directly when creating an account (name, email,
              organization details), content you submit to the platform, and technical data such as
              log files, device identifiers, and usage events. When you connect a third-party
              platform (Facebook, Google, Instagram, and others), we receive data from that
              platform according to the permissions you grant.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">How We Use Information</Header>
            <Box variant="p">
              We use collected information to provide and improve the service, authenticate users,
              publish content to platforms you authorize, generate analytics, and communicate with
              you about your account. We do not sell personal information.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Third-Party Platforms</Header>
            <Box variant="p">
              When you connect Facebook, Google, or another supported platform, that platform's
              privacy policy also applies to data they share with us. You can revoke access at any
              time from the Settings page or from the platform's own application settings.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Data Retention and Deletion</Header>
            <Box variant="p">
              We retain your data for as long as your account is active. You may request deletion
              of your account and associated data at any time. See our{' '}
              <Link href="/data-deletion">Data Deletion</Link> page for instructions.
            </Box>
          </SpaceBetween>

          <SpaceBetween size="m">
            <Header variant="h2">Contact</Header>
            <Box variant="p">
              Questions about this policy can be sent to{' '}
              <Link href="mailto:privacy@sabar.ai">privacy@sabar.ai</Link>.
            </Box>
          </SpaceBetween>
        </SpaceBetween>
      </Container>
    </Box>
  )
}
